<template>
  <div>
    <form
      @submit.prevent="sendEmail"
      class="mail-form main-modal main-modal_w560"
    >
      <div class="main-modal__title">
        <h2>{{ $t("mails.createTitle") }}</h2>
      </div>

      <div class="main-form__box">
        <label class="main-form__label" for="">Email</label>
        <input
          class="main-form__input"
          type="text"
          v-model="form.to"
          v-validate="'required'"
        />
      </div>

      <div class="main-form__box">
        <label class="main-form__label" for="">{{ $t("mails.subject") }}</label>
        <input
          class="main-form__input"
          type="text"
          v-model="form.subject"
          v-validate="'required'"
        />
      </div>

      <div class="main-form__box">
        <label class="main-form__label" for="">{{ $t("mails.message") }}</label>
        <textarea
          class="main-form__textarea"
          cols="30"
          rows="10"
          v-model="form.message"
          v-validate="'required'"
          data-vv-as="message"
          name="message"
        ></textarea>
      </div>

      <div class="custom-file custom-file_mt">
        <input type="file" multiple id="upload-file" @change="uploadFile" />

        <label for="upload-file">
          <div class="svg-box">
            <svg
              width="20px"
              fill="var(--menu-text-color)"
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              viewBox="0 0 456.682 456.682"
              xml:space="preserve"
            >
              <g>
                <g>
                  <path
                    d="M447.976,138.861c-7.544-9.4-18.776-14.568-30.824-14.568H399.24c-3.52-16-19.384-32-38.4-32H168
                                        c-13.232,0-24-10.768-24-24c0-22.056-17.944-40-40-40H40c-22.056,0-40,17.944-40,40v320c0,22.056,17.944,40,40,40h2.704
                                        c1.712,0.216,3.432,0,5.184,0H367c18.672,0,34.528-12.552,38.576-30.776l50.152-225.576
                                        C458.344,160.173,455.52,148.261,447.976,138.861z M16,68.293c0-13.232,10.768-24,24-24h64c13.232,0,24,10.768,24,24
                                        c0,22.056,17.944,40,40,40h192.832c10.136,0,18.752,8,21.88,16H97c-18.672,0-34.528,12.552-38.576,30.776L16,345.789V68.293z
                                        M439.416,168.325l-50.152,225.888c-2.336,10.512-11.488,18.08-22.264,18.08H47.888c-7.208,0-13.928-3.408-18.448-9.032
                                        c-4.504-5.624-6.192-12.976-4.632-20.008l49.92-224.872c2.336-10.512,11.496-18.08,22.264-18.08h320.152
                                        c6.96-0.008,13.44,3.28,17.8,8.704C439.296,154.437,440.92,161.533,439.416,168.325z"
                  />
                </g>
              </g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
            </svg>
          </div>

          <div>
            <span>{{ fileInputText }}</span>
          </div>
        </label>
      </div>

      <div class="main-form__buttons main-form__buttons_center">
        <span class="main-button main-button_cancel" @click="close">{{
          $t("global.cancel")
        }}</span>
        <button
          class="main-button main-button_success"
          type="submit"
          :disabled="!isValid"
          :class="{
            disabled: !isValid,
          }"
        >
          {{ $t("mails.send") }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
    name: 'send-mail',
    data() {
        return {
            fileInputText: this.$t('mails.chooseFile'),
        }
    },
    computed: {
        ...mapGetters({
            form: 'mails/formGetters',
        }),
        isValid() {
            if (this.form.subject === '' || this.form.subject === undefined) {
                return false
            }

            return !(this.form.message === '' || this.form.message === undefined)
        },
    },
    methods: {
        ...mapActions({
            send: 'mails/send',
        }),
        ...mapMutations({
            setFile: 'mails/setFile',
            clearForm: 'mails/clearForm',
        }),
        sendEmail() {
            this.$validator.validate().then((valid) => {
                if (!valid) return

                const result = this.send()

                if (result) {
                    this.$notify({
                        title: this.$t('notifications.mailSent'),
                        message: this.$t('notifications.mailSentText'),
                        duration: 5000,
                    })

                    this.clearForm()
                }
            })
        },
        uploadFile({ target }) {
            const { files } = target

            if (files.length === 0) {
                return
            }

            let tmpName = ''
            files.forEach((element) => {
                tmpName += `${element.name} `
            })

            if (tmpName === '') {
                return
            }

            this.fileInputText = tmpName
            this.setFile(files[0])
        },
        close() {
            this.$emit('close')

            setTimeout(() => {
                this.clearForm()
            }, 400)
        },
    },
}
</script>

<style lang="scss" scoped>
@import "src/assets/sass/main";
.mail-form {
  //   width: 600px;
  //   padding: 20px;

  //   h2 {
  //     font-family: "SFUIDisplay-Bold";
  //     color: #4d4d4d;
  //     margin-bottom: 30px;
  //   }

  //   input,
  //   textarea {
  //     width: 100%;
  //     border-radius: 8px;
  //   }

  //   &__control {
  //     display: flex;
  //     flex-direction: column;
  //     margin-bottom: 10px;

  //     label {
  //       display: block;
  //       margin-bottom: 5px;
  //     }
  //   }

  //   .mail-form__cta {
  //     width: 140px;
  //     height: 40px !important;
  //     border-radius: 8px;
  //     background-color: #61422d;
  //     box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  //     border: none;
  //     font-family: "SFUIDisplay-Bold";
  //     font-size: 15px;
  //     text-align: center;
  //     color: #ffffff;
  //     cursor: pointer;
  //     -webkit-transition: 0.5s;
  //     transition: 0.5s;
  //     outline: none;
  //     display: flex;
  //     justify-content: center;
  //     align-items: center;
  //     margin: 10px;

  //     &:hover {
  //       background-color: #fcee21;
  //       color: #000000 !important;
  //     }
  //   }

  &__actions {
    width: 60%;
    display: flex;
    justify-content: space-around;
    margin: 0 auto;
  }

  textarea {
    height: 90px;
    padding-top: 10px;
  }
}
</style>
